//                       __
//    ____  ____ __   __/ /_  ____ ______
//   / __ \/ __ `/ | / / __ \/ __ `/ ___/
//  / / / / /_/ /| |/ / /_/ / /_/ / /
// /_/ /_/\__,_/ |___/_.___/\__,_/_/

/* globals */

import debounce from 'javascript-debounce';

const setupNavbar = () => {
  console.log('{ setupNavbar }');

  const navbar = $('.navbar-site');
  const whiteSections = $('.bg__white');
  const navbarHeight = navbar.find('.site-link').height();
  let windowScrollTop;
  let lastScrollTop;

  // console.log( '{ setupNavbar }' );

  // ----------------------------------------------------------------------------
  //
  //
  //
  // Scroll show/reveal navbar
  //
  //
  //
  // ----------------------------------------------------------------------------
  function checkScroll() {
    windowScrollTop = $(window).scrollTop();

    // console.groupCollapsed( '{ checkScrollDirection }' );
    // console.log( 'windowScrollTop: %o', windowScrollTop);
    // console.log( 'app.scrollTop: %o', app.scrollTop );
    // console.groupEnd();

    // check top position changed
    if (windowScrollTop === lastScrollTop) {
      return;
    }

    // header height 108
    if (windowScrollTop <= navbarHeight) {
      // console.log( '00' );
      // remove solid fill but show
      navbar.addClass('show');
    } else if (windowScrollTop > lastScrollTop) {
      // console.log( '01' );
      // scrolling up
      navbar.removeClass('show');
    } else {
      // console.log( '02' );
      // scrolling down
      navbar.addClass('show');
    }

    // store current position
    lastScrollTop = windowScrollTop;
  }

  // ----------------------------------------------------------------------------
  //
  // Cursor position
  //
  // ----------------------------------------------------------------------------
  const navbarVisible = debounce(() => {
    checkScroll();
  }, 25);

  // ----------------------------------------------------------------------------
  // Scroll event listener
  // ----------------------------------------------------------------------------
  // Reset window scroll listener
  window.removeEventListener('scroll', navbarVisible);
  window.addEventListener('scroll', navbarVisible);

  // ----------------------------------------------------------------------------
  // Check scroll position NOW!
  // ----------------------------------------------------------------------------
  checkScroll();

  // ----------------------------------------------------------------------------
  //
  //
  //
  // White Section - change navbar icon colours
  //
  //
  //
  // ----------------------------------------------------------------------------
  function checkOnWhite() {
    windowScrollTop = $(window).scrollTop();

    let test = false;

    $.each(whiteSections, function (i, el) {
      const elh = $(el).height();
      const offset = $(el).offset();
      const eltop = offset.top;

      // test = false;

      // console.groupCollapsed( '{ checkOnWhite }' );
      // console.log( 'offset: %o', offset );
      // console.log( 'windowScrollTop: %o', windowScrollTop );
      // console.log( 'eltop: %o', eltop );
      // console.log( 'elh: %o', elh );
      // console.groupEnd();

      if (
        windowScrollTop >= eltop + navbarHeight &&
        windowScrollTop < eltop + elh
      ) {
        // console.log( 'firing - on white' );
        test = true;
      } else {
        // console.log( 'firing - off white' );
        test = test || false;
      }
    });

    // ----------------------------------------------------------------------------
    // Use test results
    // ----------------------------------------------------------------------------
    // console.log( 'test: %o', test );
    if (true === test) {
      if (!$(navbar).find('.svg-site-logo').hasClass('gray')) {
        $(navbar).find('.svg-site-logo').addClass('gray');
        $(navbar).find('.svg-main-nav').addClass('gray');
        $(navbar).find('.back-link').addClass('gray');
      }
    } else {
      if ($(navbar).find('.svg-site-logo').hasClass('gray')) {
        $(navbar).find('.svg-site-logo').removeClass('gray');
        $(navbar).find('.svg-main-nav').removeClass('gray');
        $(navbar).find('.back-link').removeClass('gray');
      }
    }
  }

  // only setup if page has bg__white section
  if (whiteSections.length) {
    // console.log( 'whiteSections: %o', whiteSections );

    // ----------------------------------------------------------------------------
    //
    // Cursor position
    //
    // ----------------------------------------------------------------------------
    const checkWhiteBackground = debounce(() => {
      checkOnWhite();
    }, 40);

    // ----------------------------------------------------------------------------
    // Scroll event listener
    // ----------------------------------------------------------------------------
    window.addEventListener('scroll', checkWhiteBackground);

    // ----------------------------------------------------------------------------
    // Check scroll position NOW!
    // ----------------------------------------------------------------------------
    checkOnWhite();
  }
};

export { setupNavbar };



// WEBPACK FOOTER //
// ./scripts/modules/navbar.js